import { withProps } from 'recompose'
import badaPropsChange from './BadaProps'
import wizardChange from './Wizard'

const reducer = withProps(
  ({
    storesByAddressData: { stores },
    StoreWithDistance,
    selectedStore,
    selectedService,
    selectedSlot,
    bookingCompleted,
    prepCompleted,
    overrideMeetingType,
    pageContentServices,
  }) => ({
    wizard: wizardChange({
      selectedStore,
      selectedService,
      selectedSlot,
      bookingCompleted,
      prepCompleted,
      pageContentServices,
    }),
    badaProps: badaPropsChange({
      stores,
      StoreWithDistance,
      overrideMeetingType,
    }),
  })
)

export default reducer
